import { signal } from "@angular/core";
import { debounce, SchemaPathTree, validate } from "@angular/forms/signals";
const DEFAULT_MAX_TEXT_VALUE = "∞";
const DEFAULT_MIN_TEXT_VALUE = "";

const defaultMaxBuildyear = new Date().getFullYear();
const defaultMinBuildyear = 1500;

export interface BuildYearFilterModel {
    buildYearFrom: string | null;
    buildYearTo: string | null;
    expanded: boolean;
}

export function createBuildYearModel() {
    return signal<BuildYearFilterModel>({
        buildYearFrom: DEFAULT_MIN_TEXT_VALUE,
        buildYearTo: DEFAULT_MAX_TEXT_VALUE,
        expanded: true,
    });
}

export function buildBuildYearModel(a: SchemaPathTree<BuildYearFilterModel>) {
    debounce(a.buildYearFrom, 1000);
    debounce(a.buildYearTo, 1000);
    maxBuildyearValidator(a.buildYearTo);
    minBuildyearValidator(a.buildYearFrom, a.buildYearTo);
}

function maxBuildyearValidator(field: any) {
    validate(field, ({ value }) => {
        const maxBuildyear = value();
        if (defaultMinBuildyear != null && maxBuildyear !== "" && +maxBuildyear < defaultMinBuildyear) {
            return {
                kind: "belowLimit",
                message: `Fra-verdi er lavere enn tillatt minsteverdi (${defaultMinBuildyear}).`,
            };
        } else if (defaultMaxBuildyear != null && maxBuildyear !== "" && +maxBuildyear > defaultMaxBuildyear) {
            return {
                kind: "aboveLimit",
                message: `Til-verdi er høyere enn tillatt maksverdi (${defaultMaxBuildyear}).`,
            };
        }
        return null;
    });
}

function minBuildyearValidator(field: any, validateAgainstField?: any) {
    validate(field, ({ value, valueOf }) => {
        let minBuildyear = value();
        let maxBuildyear = valueOf(validateAgainstField);
        if (minBuildyear != null && minBuildyear !== "" && defaultMinBuildyear != null && +minBuildyear < defaultMinBuildyear) {
            return {
                kind: "belowLimit",
                message: `Fra-verdi er lavere enn tillatt minsteverdi (${defaultMinBuildyear}).`,
            };
        } else if (minBuildyear != null && minBuildyear !== "" && defaultMaxBuildyear != null && +minBuildyear > defaultMaxBuildyear) {
            return {
                kind: "aboveLimit",
                message: `Til-verdi er høyere enn tillatt maksverdi (${defaultMaxBuildyear}).`,
            };
        } else if (minBuildyear != null && minBuildyear !== "" && maxBuildyear != null && maxBuildyear !== "" && maxBuildyear !== "∞" && +minBuildyear > +maxBuildyear) {
            return {
                kind: "aboveMax",
                message: "Fra-verdi er høyere enn Til-verdi.",
            };
        }
        return null;
    });
}
